import { COMPANY_EDIT_FIELDS, COMPANY_FIELDS, DEFAULT_DOCUMENT_TYPES, IDENTITY, USER_FIELDS, getCustomerSections, isPolishCountry, toFormValues } from '../Contract/fields'
import { selectBasket, selectBasketCustomerCompany, updateCustomerData } from 'containers/OrderDetails/basketSlice'
import { useDispatch, useSelector } from 'react-redux'
import { resetForm, updateValues } from '../formSlice'
import { useEffect, useMemo, useState } from 'react'
import useTranslation from 'hooks/useTranslation'
import { useHistory } from 'react-router-dom'
import Popup from 'components/popups/Popup'
import { STATUS } from 'utils/constants'
import { cartCustomer } from 'rest/urls'
import { POST } from 'rest/request'
import Form from '../Contract/Form'

/**
 * Edycja danych do umowy na ekranie wyboru danych do faktury, zapis przez POST /cart/customer
 * (jak na /contract):
 * - bez `company` — dane klienta (wynajem prywatny), pola wg requiredInputs.private,
 * - z `company` — dane wybranej firmy (body: companyId + company).
 */
const CustomerDataPopup = ({ customer, company, customerValidation, onSaved, waitForSync }) => {
  const [status, setStatus] = useState(STATUS.idle)
  const { cartId } = useSelector(selectBasket)
  const customerCompany = useSelector(selectBasketCustomerCompany)
  const isCompany = !!company

  const dispatch = useDispatch()
  const { goBack } = useHistory()
  const { t } = useTranslation('form')

  const sections = useMemo(() => isCompany
    ? {
      identity: IDENTITY.none,
      documentTypes: DEFAULT_DOCUMENT_TYPES,
      userNames: [],
      userAddress: false,
      userIdentity: false,
      companyFields: COMPANY_EDIT_FIELDS,
    }
    : getCustomerSections(
      customerValidation?.requiredInputs?.private,
      customerValidation?.requirements
    ), [isCompany, customerValidation?.requiredInputs?.private, customerValidation?.requirements])

  // błędy z walidatora pokazujemy tylko, gdy dotyczą edytowanego podmiotu
  const validation = isCompany
    ? (customerCompany?.id && customerCompany.id === company.id ? customerValidation : undefined)
    : (customerValidation?.rentalType === 'private' ? customerValidation : undefined)
  const isLoading = status === STATUS.pending

  useEffect(() => {
    const values = isCompany
      ? toFormValues(company, COMPANY_FIELDS)
      : toFormValues(customer, USER_FIELDS)
    if (!values.cardType) delete values.cardType
    dispatch(resetForm())
    dispatch(updateValues(values))

    return () => {
      dispatch(resetForm())
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch])

  const submit = async ({ customer, company: companyData }) => {
    const body = { cartId }
    if (isCompany) {
      if (!companyData) return goBack()
      body.companyId = company.id
      body.company = companyData
    } else {
      if (!customer) return goBack()
      body.customer = customer
    }
    setStatus(STATUS.pending)

    try {
      if (waitForSync) await waitForSync()
      const response = await POST(cartCustomer, { body })
      dispatch(updateCustomerData(response))
      if (onSaved) onSaved(response)
      goBack()

    } catch (err) {
      console.error(`Error: ${err}`)
      setStatus(STATUS.failed)
    }
  }

  return (
    <Popup>
      <div
        className='popup__edit registration'
        style={{ width: '100%' }}>

        <div className='main center'>
          <div className='popup__title --sticky'>
            <div>{t(isCompany ? 'companyDetails' : 'changeData')}</div>
          </div>

          <Form
            secondaryTheme
            block={isLoading}
            isLoading={isLoading}
            sections={sections}
            validation={validation}
            isPolish={isPolishCountry(customer?.country)}
            isCompanyPolish={isPolishCountry(company?.country)}
            submit={submit} />
        </div>
      </div>
    </Popup>
  )
}

export default CustomerDataPopup
